import find from 'lodash/find'
import React from 'react'
import { blogStatusOptions } from '../BlogStatusOptions'
import { BlogStatusSelect } from '../BlogStatusSelect'
import { InlineInput } from '@ztechapps/webui.input'

export const BlogStatusInlineInput = ({
  parentInputComponent,
  displayContent,
  name = 'status',
  updateParams,
  initialValues,
  ...rest
}: any) => {
  //make sure the calcBase string, will be mapped to correctly to calcBase object
  const optionObject = find(blogStatusOptions, { value: initialValues?.[name] })

  const ParentInput = parentInputComponent || InlineInput

  return (
    <ParentInput
      {...{
        ...rest,
        initialValues: {
          //actually these two fields are just necessary for updating, according to updateParams
          _id: initialValues?._id,
          [name]: optionObject,
        },
        displayContent: displayContent || ((option) => option?.label),
        name,
        editContent: ({ setNewValue, ...rest }) => (
          <BlogStatusSelect {...{ ...rest, autoFocus: true, onChange: (e) => setNewValue(e) }} />
        ),
        updateParams:
          updateParams ||
          (({ updatedValue }) => ({
            input: {
              _id: initialValues._id,
              [name]: updatedValue.value,
            },
          })),
      }}
    />
  )
}
